<template>
    <div class="panel-view">
        <panel-header
            :is-offline="isOffline"
        ></panel-header>

        <h2 v-if="controlVoiceChecker">
            {{ $t('twitch.controlVoice') }}
        </h2>

        <router-view></router-view>

        <panel-footer>
        </panel-footer>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import PanelHeader from '@Views/PanelView/PanelHeader/PanelHeader';
import PanelFooter from '@Views/PanelView/PanelFooter/PanelFooter';

export default {
    name: 'PanelView',

    components: {
        PanelHeader,
        PanelFooter,
    },

    computed: {
        ...mapState({
            twitchStore: state => state.twitchSettings,
        }),

        isOffline() {
            return this.twitchStore.offline;
        },

        controlVoiceChecker() {
            return this.$route.name === 'Offline' || this.$route.name === 'VoicesList';
        },
    },

    watch: {
        isOffline(value) {
            const routePush = value ? 'Offline' : 'VoicesList';

            this.$router.push({ name: routePush });
        },
    },

    mounted() {
        this.axn_viewerSubscriptionStatus(this.$twitch.viewer.subscriptionStatus);
    },

    methods: {
        ...mapActions({
            axn_viewerSubscriptionStatus: 'global/axn_viewerSubscriptionStatus',
        }),
    },
};
</script>

<style src="./PanelView.scss" lang="scss" scoped></style>
